// eslint-disable-next-line no-shadow
export enum NavigationTargetEnum {
  HOME = 'HOME',
  LIST = 'ASSESSMENTS',
  SCOREBOARD = 'SCOREBOARD',
  IMPROVEMENTS = 'IMPROVEMENTS',
}
